import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  ButtonGroup,
} from '@chakra-ui/react';
import { type FC, useRef } from 'react';

interface UnsavedChangesDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isNewPage?: boolean;
}

export const UnsavedChangesDialog: FC<UnsavedChangesDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isNewPage = false,
}) => {
  const cancelRef = useRef(null);
  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader>
            {isNewPage ? 'Exit without creating?' : 'Discard changes?'}
          </AlertDialogHeader>
          <AlertDialogBody>
            {isNewPage
              ? 'Your new dashboard has not been created yet. Are you sure you want to exit?'
              : 'You have unsaved changes. They will be lost if you discard and exit.'}
          </AlertDialogBody>
          <AlertDialogFooter>
            <ButtonGroup>
              <Button
                ref={cancelRef}
                variant="ghost"
                colorScheme="navyBlue"
                onClick={onClose}
              >
                Back
              </Button>
              <Button colorScheme="red" onClick={onConfirm}>
                {isNewPage ? 'Cancel & Exit' : 'Discard & Exit'}
              </Button>
            </ButtonGroup>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
